import { Redeem } from '../../redeem/views/redeem';

export const BrnachDashboard: React.FC = () => {
  return <Redeem />;
};
